import { render } from "./OrgAdminList.vue?vue&type=template&id=60c3849e&scoped=true"
import script from "./OrgAdminList.vue?vue&type=script&lang=js"
export * from "./OrgAdminList.vue?vue&type=script&lang=js"

import "./OrgAdminList.vue?vue&type=style&index=0&id=60c3849e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c3849e"]])

export default __exports__